import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=98c7920c&scoped=true"
import script from "./highlight.vue?vue&type=script&lang=ts"
export * from "./highlight.vue?vue&type=script&lang=ts"
import style0 from "./highlight.vue?vue&type=style&index=0&id=98c7920c&prod&lang=scss&scoped=true"
import style1 from "./highlight.vue?vue&type=style&index=1&id=98c7920c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c7920c",
  null
  
)

export default component.exports